import api from "../../service/api";
import { Calc } from "../../tools/BN";
import ConfigureInfo from "@/connect/configureInfo";

const getSum = (arr) => {
  const result = [];

  for (let i = 0; i < arr.length; i++) {
    result[i] = {
      ...arr[i],
      sum: Calc.setBN({ DECIMAL_PLACES: 6 })
        .init(arr[i].amount)
        .plus(result[i - 1] ? result[i - 1].sum : "0")
        .result(false),
    };
  }

  return result;
};

export default {
  namespaced: true,
  state: () => ({
    asks: [],
    bids: [],
    orderBookloading: true,
  }),
  getters: {
    asksSum: (state) =>
      getSum(state.asks.sort((a, b) => Number(a.price) - Number(b.price))),
    bidsSum: (state) =>
      getSum(state.bids.sort((a, b) => Number(b.price) - Number(a.price))),
    asksMax: (state) => Math.max(0, ...state.asks.map((ele) => ele.amount)),
    bidsMax: (state) => Math.max(0, ...state.bids.map((ele) => ele.amount)),
    orderBookloading: (state) => state.orderBookloading,
  },
  mutations: {
    SET_ORDER_BOOK_LOADING(state, data) {
      state.orderBookloading = data;
    },
    SET_QUERY_ORDER_BOOK_DATA(state, opt) {
      state.asks = opt.asks;
      state.bids = opt.bids;
      // state.asks = opt.askOrderBookList;
      // state.bids = opt.bidOrderBookList;
    },
    UPDATE_ORDER_BOOK_DATA(state, opt) {
      if (opt.data && opt.data.length) {
        opt.data.forEach((ele) => {
          for (let i = 0, len = state[opt.type].length; i < len; i++) {
            if (state[opt.type][i].price === ele.price) {
              state[opt.type][i].amount = ele.amount;
              // state[opt.type][i].amount = Calc.setBN({ DECIMAL_PLACES: 6 })
              //   .init(state[opt.type][i].amount)
              //   .plus(ele.amount)
              //   .result(false);

              if (Number(state[opt.type][i].amount) <= 0) {
                state[opt.type].splice(i, 1);
              }
              return;
            }
          }

          if (Number(ele.amount) > 0) {
            state[opt.type].unshift({
              amount: ele.amount,
              pair: ele.pair,
              price: ele.price,
            });
          }
        });
      }
    },
  },
  actions: {
    async getQueryOrderBook({ commit, rootState }, opt) {
      commit("SET_ORDER_BOOK_LOADING", true);

      const queryOrderBookrData = await api["queryOrderBook"]({
        pair: opt.pair,
      });

      rootState.ws.websocketsend({
        type: "subscribe",
        channel: "order_book",
        id: rootState.tradingPair.queryPairInfo.pair,
        last_height: queryOrderBookrData.blockHeight,
        chainId: ConfigureInfo.Marginx.chainId,
      });

      commit("SET_QUERY_ORDER_BOOK_DATA", queryOrderBookrData);

      commit("SET_ORDER_BOOK_LOADING", false);
    },

    setOrderBook({ commit }, data) {
      // data.forEach((value) => {
      if (data) {
        commit("UPDATE_ORDER_BOOK_DATA", {
          type: "asks",
          data: data.asks,
        });

        commit("UPDATE_ORDER_BOOK_DATA", {
          type: "bids",
          data: data.bids,
        });
      }
      // });
    },
  },
};
